import { render, staticRenderFns } from "./EditDocumentType.vue?vue&type=template&id=cfd40a52&"
import script from "./EditDocumentType.vue?vue&type=script&lang=ts&"
export * from "./EditDocumentType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports